module.exports = window["Vue"];